import React from 'react'
import { Meter } from 'baby-design'
import { GroupGiftProgressProps } from './GroupGiftProgress.types'
import css from './GroupGiftProgress.styles.scss'

const GroupGiftProgress: React.FC<GroupGiftProgressProps> = ({
  fundedAmount,
  goalAmount,
}) => {
  let groupGiftProgress = 0
  let stillNeeds = goalAmount

  if (fundedAmount && goalAmount) {
    groupGiftProgress = (fundedAmount / goalAmount) * 100
    stillNeeds = goalAmount - fundedAmount
  }

  return (
    <div className={css.GroupGiftProgress} data-testid="GroupGiftProgress">
      <Meter
        fillClass={css.GroupGiftProgress__fill}
        label={`Still needs $${stillNeeds.toFixed(2)}`}
        percentage={groupGiftProgress}
        size="sm"
      />
    </div>
  )
}

export default GroupGiftProgress
